import type { OrderLineWithTotalPrice } from '@/types/orderDetailsOrder';

import type { OrderFragment } from '@/graphql/saleor/api';
import { VOUCHER_TYPE } from '@/lib/const';
import { orderGwpUpdate } from '@/lib/order';
import { GWP } from '@/states/checkout';

import type { WithRequired } from './tsutils';

export const getOrderLineUnitPriceWithoutDiscount = (
  orderLine: WithRequired<Partial<OrderLineWithTotalPrice>, 'totalPrice'>,
  voucherType?: string,
) => {
  const { totalPrice, undiscountedUnitPrice, unitDiscount } = orderLine;

  if (
    (!undiscountedUnitPrice && !unitDiscount) ||
    undiscountedUnitPrice?.gross.amount === 0 ||
    voucherType === VOUCHER_TYPE.PERCENTAGE
  )
    return totalPrice;

  return {
    ...totalPrice,
    gross: {
      ...totalPrice.gross,
      ...(undiscountedUnitPrice &&
        unitDiscount && {
          amount: undiscountedUnitPrice.gross.amount - unitDiscount.amount,
        }),
    },
    net: {
      ...totalPrice.net,
      ...(undiscountedUnitPrice &&
        unitDiscount && {
          amount: undiscountedUnitPrice.net.amount - unitDiscount.amount,
        }),
    },
  };
};

export const orderGwpProductUpdate = async (
  order: OrderFragment,
  gwpProductId?: string,
) => {
  const orderId = order.id;

  const lineId = order?.lines?.find(
    (item) =>
      item.variant?.product.productType.slug.toLocaleLowerCase() === 'gift',
  )?.id;
  const errors = await orderGwpUpdate({
    id: orderId,
    orderGwp: {
      gwpProductId:
        gwpProductId === GWP.doNotNeedGift ? '' : (gwpProductId ?? ''),
      lineIdToRemove: lineId ?? '',
    },
  });

  if (errors?.length) {
    return errors;
  }

  return [];
};
